import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmarticle/cecUnmArticle/save',
      method: 'post',
      data: inputForm
    })
  },
  batchOperation: function (inputForm) {
    return request({
      url: '/unmarticle/cecUnmArticle/batchOperation',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmarticle/cecUnmArticle/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmarticle/cecUnmArticle/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  getMaxSort: function () {
    return request({
      url: '/unmarticle/cecUnmArticle/maxSort',
      method: 'get'
    })
  },

  list: function (params) {
    return request({
      url: '/unmarticle/cecUnmArticle/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmarticle/cecUnmArticle/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmarticle/cecUnmArticle/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmarticle/cecUnmArticle/import',
      method: 'post',
      data: data
    })
  }
}
